import { Phone } from 'lucide-react';

// Highly-visible RED notice: quotes confirmed by phone/text may beat the on-screen estimate.
export const PhonePriceNote = ({ idPrefix = 'sell', className = '' }) => (
  <div
    className={`flex items-start gap-2.5 rounded-xl border-2 border-red-500 bg-red-50 px-3 py-2.5 shadow-sm ${className}`}
    data-testid={`${idPrefix}-phone-price-note`}
    role="note"
  >
    <span className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-red-500/20">
      <Phone className="h-3.5 w-3.5 text-red-600" />
    </span>
    <p className="text-[12px] sm:text-[13px] font-bold leading-snug text-red-700 text-left">
      Prices confirmed by{' '}
      <span className="font-black underline decoration-red-500 decoration-2 underline-offset-2">phone call or text</span>{' '}
      may be <span className="font-black uppercase text-red-600">higher</span> than this estimate — call or text us to check!
    </p>
  </div>
);
